import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const approachDefinition: ResourceDefinition = {
  title: 'Approachs',
  nameSingular: 'Approach',
  namePlural: 'Approachs',
  className: 'Approach',
  mainIdentifier: 'name',
  slug: 'taxonomies/approaches',
  path: 'approaches',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (approach) => ({
        type: ActionType.Link,
        link: {
          path: `${approachDefinition.path}/${approach.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (approach) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: approach,
          definition: approachDefinition
        }
      })
    }
  ]
}
